export const iconFontAwesomeShoppingBullhorn = (
	<i className="fa-solid fa-bullhorn"></i>
);
